import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export interface IRemoveIconProps extends IConDefaultType {}

function RemoveIcon({ color, className, size = 24, rotate, flip }: IRemoveIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.524 13.4474C18.8292 12.9871 19.4497 12.8614 19.91 13.1666L21.5526 14.2557C21.8327 14.4414 22.0007 14.7553 22 15.0914C21.9993 15.4274 21.8298 15.7406 21.549 15.925L12.549 21.8358C12.2157 22.0547 11.7843 22.0547 11.451 21.8358L2.45105 15.925C2.16712 15.7385 1.99727 15.4207 2.00003 15.081C2.0028 14.7413 2.17781 14.4263 2.46474 14.2445L4.10799 13.2032C4.5745 12.9076 5.19232 13.0461 5.48794 13.5126C5.78356 13.9791 5.64503 14.5969 5.17852 14.8925L4.84453 15.1042L12 19.8036L19.1844 15.0852L18.8048 14.8334C18.3445 14.5282 18.2188 13.9076 18.524 13.4474Z"
          fill={color || EColorMap.gray_0}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.411 3.16923C11.7467 2.94427 12.1849 2.94354 12.5214 3.16738L21.5538 9.17557C21.8327 9.36107 22.0002 9.67387 22 10.0088C21.9998 10.3438 21.8319 10.6564 21.5528 10.8415L12.5204 16.8333C12.1843 17.0562 11.7473 17.0555 11.412 16.8315L2.44444 10.8397C2.16692 10.6542 2.00021 10.3426 2 10.0088C1.99979 9.67505 2.16611 9.36319 2.44339 9.17741L11.411 3.16923ZM11.9696 5.20236L4.79828 10.0071L11.9696 14.7987L19.1927 10.0071L11.9696 5.20236Z"
          fill={color || EColorMap.gray_0}
        />
      </svg>
    </i>
  );
}

export default RemoveIcon;
